/**
 * Table Checkmark
 * Checkmark icon used by some tables to show if something is true or false
 */
import React from 'react';

import Status from '@components/Status';

export const TableCheckmark: React.FC<{ value: boolean }> = ({
  value = false,
}) => {
  if (!value) {
    return null;
  }

  return <Status icon="circle-check" variant="blue" />;
};
